
  import topTableInit from '../plugins/topTableInit';
  export default {
    name: 'StoreDesigns',
    mixins: [topTableInit],
    components: {
      StoreDesignsList: () => import('@mtntop/utils/src/components/StoreDesignsList'),
    },
  };
